import React, { useState, useEffect } from "react";
import { Link } from "gatsby"
import loadable from "@loadable/component"
//import Select from 'react-select';
import { Container, Row, Col } from 'react-bootstrap'
import { useStaticQuery, graphql } from "gatsby"

import "./LocationBlock.scss";
import BoxBlock from "../BoxBlock/Box"
import ContentModule from "../../modules/content_module";

import {OfficeList, AreaList} from "../../common/queries/common_use_query"

const Select = loadable(() => import("react-select"));

const Location = ({Module}) => {

    const data = useStaticQuery(graphql`
        query OfficeList{
            glstrapi {
                offices(sort:"sort:ASC", where:{publish:true}) {
                    id
                    slug
                    name
                    address
                    mobile
                    email
                    office_crm_id
                    areas{
                    id
                    area_name
                    }
                    image{
                    url
                    alternativeText
                    }
                    imagetransforms
                    ggfx_results {
                        id
                        transforms
                        src_cftle
                        src_url
                    }
                    sort
                }
            }
        }
    `)
    
   
    const[office_list, setOfficeList] = useState(data.glstrapi.offices);
    const[filter_area, setFiltArea] = useState('');
    const[searchArea, setSearchArea] = useState('');

    //const{loading, error, data} = OfficeList();
    const{data:area_data} = AreaList();

    

    var office_data = data.glstrapi.offices;

    // useEffect(() => {
    //     data?.offices?.length > 0 && setOfficeList(data?.offices);
    // }, [data])

    useEffect(() =>{
        //console.log("filter_area", filter_area);
        
        if(office_data && office_data?.length > 0){
            var all_office = office_data;
            var office_list =  [...all_office];

            if(filter_area){
                //console.log("test_address ==> filter_area", filter_area)
                var filter_branch = []
                office_list?.map((item, index) => {
                    if(filter_area?.value){
                        if(item?.areas.length > 0 && item?.areas?.some(item2 =>  item2.id === filter_area?.value)){
                            filter_branch.push(item);
                        }
                    } else{
                        filter_branch.push(item);
                    }
                })

                office_list = filter_branch
            } 
            if(searchArea){
                office_list = office_list.filter(item => item.address.toLowerCase().includes(searchArea.toLowerCase()) || item.name.toLowerCase().includes(searchArea.toLowerCase()))

                //console.log("test_address ==> searchArea", searchArea, office_list)
            }

            setOfficeList(office_list)
        }
    },[filter_area, office_data, searchArea])

    const options =  [{ value: '', label: 'All Locations' }]

    area_data?.areas?.length > 0 && area_data?.areas?.map((item, index) => {
        options.push({value: item.id, label: item.area_name})
    })

    var branche_text = office_list?.length > 1 ? "branches" : "branch"

    var test_address = "Brighton Marina"

    //console.log("test_address ==>", test_address.indexOf("Marina"), office_list)

    return (
        <React.Fragment>
            <section className="location-block">
                <Container>
                    <Row>
                        <Col>
                            {(process.env.GATSBY_SITE_NAME === "Brandvaughan" || process.env.GATSBY_SITE_NAME === "Michael Jones" || process.env.GATSBY_SITE_NAME === "Chase Evans" || process.env.GATSBY_SITE_NAME === "Charters") && 
                            <div className="location-search-box">
                                <input
                                className="form-control location-search"
                                placeholder="Search by area or postcode"
                                onChange={(event) => setSearchArea(event.target.value)}
                                // value={search}
                                />
                                <button class="search-icon"><i class="icon-search"></i> <span class="d-none d-xl-flex">Search</span></button>
                            </div>
                            }
                            
                            {Module.description && <ContentModule Content={Module.description} />}

                            <div className="filter-wrapper">
                                {filter_area ?
                                    <span className="sm-text">Showing {office_list?.length} {branche_text} across the {filter_area?.label}</span>
                                :
                                    <span className="sm-text">Showing all {office_list?.length} {branche_text}</span>
                                }

                                <div className="filter-boxes">
                                    <strong className="filter-box">Filter by:</strong>
                                    <Select 
                                        options={options}
                                        placeholder="All Locations" 
                                        className="react-select"
                                        classNamePrefix="react-select" 
                                        onChange={setFiltArea}                                        
                                    />
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            {office_list?.length > 0 && 
                            <div className="box-wrap">
                                {office_list.map((item, index) => (
                                    <BoxBlock key={index} BoxList={item} />
                                ))}
                            </div>
                            }
                        </Col>
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    );
};
export default Location;
